var _style, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMotionIcon01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "listos",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M50,22c3.3,0,6,2.7,6,6c0,3.3-2.7,6-6,6c-3.3,0-6-2.7-6-6C44,24.7,46.7,22,50,22L50,22z M62,68.5v8 c15.8,1.3,25.7,5.1,29.1,7.5c-4.2,3-18.2,8-41.1,8c-22.9,0-36.9-5-41.1-8c3.4-2.4,13.3-6.2,29.1-7.5v-8C16.2,70.2,0,76.5,0,84 c0,8.8,22.4,16,50,16s50-7.2,50-16C100,76.5,83.8,70.2,62,68.5z M54,55.7V84h-8V55.7C32.4,53.8,22,42.1,22,28C22,12.5,34.5,0,50,0 c15.5,0,28,12.5,28,28C78,42.1,67.6,53.8,54,55.7z M66,28c0-8.8-7.2-16-16-16s-16,7.2-16,16c0,8.8,7.2,16,16,16S66,36.8,66,28z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotionIcon01);
export default __webpack_public_path__ + "static/media/motion_icon-01.2fb62729.svg";
export { ForwardRef as ReactComponent };